/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsArticle = {
  init: function($section){

    this.container = $section[0];

    // Add settings from schema to current object
    window.PXUTheme.jsAccountsArticle = $.extend(this, window.PXUTheme.getSectionData($section));

    // Selectors
    var relatedBlogsContainer = this.container.querySelector(".related-blogs--content");

    var relatedBlogsCarousel = new Flickity(relatedBlogsContainer, {
      watchCSS: true,
      cellAlign: "left",
      wrapAround: true,
      adaptiveHeight: false,
      prevNextButtons: false,
      pageDots: this.number_of_slides > 1,
      draggable: true,
      selectedAttraction: 0.2,
      friction: 0.8,
      arrowShape: { 
        x0: 10,
        x1: 50, y1: 50,
        x2: 70, y2: 50,
        x3: 30
      }
    });

    // Resize flickity when the slider is settled
    relatedBlogsCarousel.on( 'settle.flickity', function() {
      relatedBlogsCarousel.resize();
    })

  },

  unload: function($section) {

  }
}

/******/ })()
;